// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { load } from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/product-form/product-form';
import 'snippets/product-zoom/product-zoom';
import 'snippets/product-sfp-zoom/product-sfp-zoom';
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/main-product/main-product';
import 'sections/main-bundle-product/main-bundle-product';
import 'sections/product-recommendations/product-recommendations';
import 'sections/bv-reviews/bv-reviews';

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});